import React from 'react';

export const NotFound = () => <h3>Ups. Denne side findes ikke.</h3>;
export default NotFound;
